import { Component, OnInit } from '@angular/core';
import { SideServiceService } from 'src/app/services/side-service.service';


@Component({
  selector: 'app-right-side',
  templateUrl: './right-side.component.html',
  styleUrls: ['./right-side.component.css']
})
export class RightSideComponent implements OnInit {
  retItems: any;
  retPosts: any;
  constructor(private sideService: SideServiceService) { 

  }

  ngOnInit() {

      this.getCatCounts();
      this.getRecentPosts();
  }
  getCatCounts() {
    
    this.sideService.getCatCounts().subscribe((data) => {
      this.retItems = data;
    }), 
    err => {
         console.log(err);
      }
  }
  getRecentPosts() {
    
    this.sideService.getRecentPosts().subscribe((data) => {
      this.retPosts = data;
    }), 
    err => {
         console.log(err);
      }
  }

}
